import { render, staticRenderFns } from "./Editors.vue?vue&type=template&id=f8057374&"
import script from "./Editors.vue?vue&type=script&lang=js&"
export * from "./Editors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports